import { ArrowRight, Radio } from 'lucide-react';

export function JournalPage() {
  return (
    <>
      <main id="content" className="journal-main" tabIndex={-1}>
        <section className="journal-hero shell">
          <div>
            <p className="eyebrow">Spoolmark build notes</p>
            <h1>Notes from the workbench.</h1>
          </div>
          <p>
            One note so far. More when there is something useful to document—not
            because a publishing calendar says so.
          </p>
        </section>

        <section
          className="journal-index shell"
          aria-labelledby="latest-writing"
        >
          <div className="journal-index-label">
            <h2 id="latest-writing">Latest note</h2>
            <span>Updated Sep 2026</span>
          </div>

          <article>
            <a
              className="article-card-featured"
              href="/spoolmark/blog/bambu-lab-spool-scanning-on-ios"
              aria-label="Read How I Made Bambu Lab Spool Scanning Work on iPhone"
            >
              <div className="article-card-art" aria-hidden="true">
                <span>Field note / 01</span>
                <div className="article-art-type">
                  <strong>NFC</strong>
                  <small>iPhone · camera · Bluetooth</small>
                </div>
                <div className="article-signal">
                  <Radio size={40} strokeWidth={1.25} />
                </div>
              </div>

              <div className="article-card-copy">
                <p className="eyebrow">Field note · Aug 2026 · 2 min</p>
                <h3>How I Made Bambu Lab Spool Scanning Work on iPhone</h3>
                <p>
                  An iPhone cannot read original Bambu Lab RFID tags directly.
                  A look at camera intake and the optional Bluetooth reader
                  integration in the iPhone development build, with its current
                  limits.
                </p>
                <span className="text-link">
                  Read the note
                  <ArrowRight size={17} aria-hidden="true" />
                </span>
              </div>
            </a>
          </article>
        </section>

        <section className="journal-note shell">
          <span className="journal-note-number">A / 01</span>
          <div>
            <p className="eyebrow">Why write this down?</p>
            <h2>Useful notes, only when they are useful.</h2>
            <p>
              This is a small product journal, not a content machine. Each note
              should explain how something works, where it stops, and why a
              decision was made.
            </p>
            <a className="text-link" href="/spoolmark">
              Explore Spoolmark <ArrowRight size={16} aria-hidden="true" />
            </a>
          </div>
        </section>
      </main>
    </>
  );
}
